export enum NotificationStatus {
    InProcess = 'In Process',
    Closed = 'Closed'
}
